<template>
  <BfFlex
    direction="column"
    gap="0.8rem"
  >
    <SaddleHardware />
    <HandlebarHardware />
    <CranksetHardware />
    <PedalHardware />
  </BfFlex>
</template>

<script setup lang="ts">
import CranksetHardware from '@/components/setup/crankset/CranksetHardware.vue'
import HandlebarHardware from '@/components/setup/handlebar/HandlebarHardware.vue'
import PedalHardware from '@/components/setup/pedal/PedalHardware.vue'
import SaddleHardware from '@/components/setup/saddle/SaddleHardware.vue'
import { BfFlex } from '@finetic/bikefitting-ui'
</script>

<style lang="scss"></style>
